export default __webpack_public_path__ + "static/media/vire15.37665515.jpg";